import React from "react";
import { GetServerSideProps, InferGetServerSidePropsType } from "next";
import classNames from "classnames";
import Link from "next/link";
import SubjectDetailHelmet from "./SubjectDetailHelmet";
import TitleCard from "./TitleCard";
import styles from "./index.module.scss";
import PopularTags from "./PopularTags";
import { goPcmSeoCrTopicDetail, GoPcmSeoCrTopicDetailResponse } from "@/api";
import to from "await-to-js";
import BookCardList from "@/components/Book/BookCardList";
import { BookTypeEnum, IBook } from "@/interface/IBook";
import Header from "@/components/Layout/Header";
import ResponsiveWrap from "@/components/Layout/ResponsiveWrap";
import { composeChapterUrl, getHost } from "@/utils/URL";

const SubjectDetail = (
  props: InferGetServerSidePropsType<typeof subjectDetailGetServerSideProps>
) => {
  const { data } = props;
  const { recommendInfo, relationTopics = [], topicInfo } = data;

  return (
    <div className={classNames(styles.container)} key={topicInfo?.topicId}>
      <SubjectDetailHelmet
        subjectWord={topicInfo?.topicName ?? ""}
        topicId={topicInfo?.topicId ?? ""}
        bookNames={recommendInfo?.contentItems?.map((item) => item.name ?? "")}
      />
      <Header />
      <ResponsiveWrap
        className={classNames(styles.responsiveWrap, "pt16 pb36 pr")}
        maxWidth={932}
      >
        <TitleCard title={topicInfo?.topicName} />
        <BookCardList
          list={(recommendInfo?.contentItems as IBook[]) ?? []}
          handleBookLink={(bookInfo) =>
            getHost() +
            composeChapterUrl({
              bookId: bookInfo.bookId,
              bookName: "",
              novelType: BookTypeEnum.Novel,
              isPureId: true,
            })
          }
        />
        <PopularTags
          className="mt32"
          list={relationTopics}
          title={"Related Topics"}
        />
      </ResponsiveWrap>
    </div>
  );
};

export const subjectDetailGetServerSideProps: GetServerSideProps<{
  data: GoPcmSeoCrTopicDetailResponse;
  topicId: string;
}> = async (ctx) => {
  const { query } = ctx;
  const topicId = query.cate as string;

  const [err, data] = await to(goPcmSeoCrTopicDetail({ topicId }, {}, ctx));

  if (err) {
    return {
      redirect: {
        statusCode: 302,
        destination: "/",
      },
    };
  }

  // 404
  if (!data.topicInfo?.topicName) {
    return {
      redirect: {
        statusCode: 302,
        destination: "/",
      },
    };
  }

  return {
    props: {
      data,
      topicId,
    },
  };
};

export default SubjectDetail;
